import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Import Images
import testPic1 from "../../images/testimonials/pic1.jpg";
import testPic2 from "../../images/testimonials/pic2.jpg";

class CommentList extends Component{
	render(){
		return(
			<>
				<ol className="comment-list">
					<li className="comment">
						<div className="comment-body">
							<div className="comment-author vcard">
								<img className="avatar photo" src={testPic1} alt=""/>
								<div className="clearfix">
									<cite className="fn">George</cite> 
									<span className="says">Menciona:</span>
									<div className="comment-meta"> <Link to="#">May 09, 2021 at 10:45 am</Link> </div>
								</div>
							</div>
							<p>xxxxxxxxxxxxxxxxxxx</p>
							<div className="reply"> <Link to="#" className="comment-reply-link">Contestar</Link> </div>
						</div>
						<ol className="children">
							<li className="comment odd parent">
								<div className="comment-body">
									<div className="comment-author vcard"> 
										<img className="avatar photo" src={testPic2} alt=""/> 
										<div className="clearfix">
											<cite className="fn">Felipe</cite> 
											<span className="says">Menciona:</span> 
											<div className="comment-meta"> <Link to="#">May 09, 2021 at 10:45 am</Link></div>
										</div>
									</div>
									<p>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>
									<div className="reply"> <Link to="#" className="comment-reply-link">Contestar</Link></div>
								</div>
							</li>
						</ol>
					</li>
					<li className="comment">
						<div className="comment-body">
							<div className="comment-author vcard"> 
								<img className="avatar photo" src={testPic1} alt=""/> 
								<div className="clearfix">
									<cite className="fn">Sonia</cite> 
									<span className="says">Menciona:</span> 
									<div className="comment-meta"> <Link to="#">May 09, 2021 at 10:45 am</Link> </div>
								</div>
							</div>
							<p>xxxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>
							<div className="reply"> <Link to="#" className="comment-reply-link">Contestar</Link> </div>
						</div>
					</li>
					<li className="comment">
						<div className="comment-body">
							<div className="comment-author vcard"> 
								<img className="avatar photo" src={testPic2} alt=""/> 
								<div className="clearfix">
									<cite className="fn">Miguel</cite>
									<span className="says">Menciona:</span>
									<div className="comment-meta"> <Link to="#">May 09, 2021 at 10:45 am</Link> </div>
								</div>
							</div>
							<p>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>
							<div className="reply"> <Link to="#" className="comment-reply-link">Constestar</Link> </div>
						</div>
					</li>
				</ol>
				
			</>
		);
	}
}

export default CommentList;